/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loud_Grassy_Iguana_MendInputs */

const fr_loud_grassy_iguana_mend = /** @type {(inputs: Loud_Grassy_Iguana_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

/**

* @param {Loud_Grassy_Iguana_MendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const loud_grassy_iguana_mend = /** @type {((inputs?: Loud_Grassy_Iguana_MendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loud_Grassy_Iguana_MendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_loud_grassy_iguana_mend(inputs)
});